import type { SxProps, Theme } from '@mui/material'
import { INTERAX_COLORS } from '../../../../constants/colors'

// The sprint call page: a title at the top left and the call filling the rest of the screen.

// Fills the shell's content area, below the menu bar on a phone, so the call's toolbar always stays on screen.
export const sprintCallPageSx: SxProps<Theme> = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: { xs: 1.5, sm: 2, md: 2 },
  overflow: 'hidden',
  p: { xs: 1.5, sm: 2, md: 2.5 },
  boxSizing: 'border-box'
}

export const sprintCallTitleSx: SxProps<Theme> = {
  color: INTERAX_COLORS.white,
  fontWeight: 600,
  fontSize: { xs: '20px', sm: '22px', md: '24px' },
  lineHeight: { xs: '28px', sm: '30px', md: '32px' }
}

export const sprintCallStageSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '16px',
  backgroundColor: INTERAX_COLORS.heritageBlue30,
  border: `1px solid ${INTERAX_COLORS.white10}`,
  p: { xs: 1.5, sm: 2, md: 2 },
  boxSizing: 'border-box',
  overflow: 'hidden'
}

export const sprintCallContentSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}
